module.exports = __webpack_public_path__ + "img/toe-off-shoe.cf64c625.svg";